import { getBarData, getPieData, getData, getFunnelData, getMap, ganttDv } from './dataSet'
/**
 *  条形图 bar
 */
export const bar = (chart, item, displayConfig) => {
  chart.data(getBarData(item));
  chart.coordinate().transpose().scale(1, -1);
  const G = chart
    .interval()
    .position(`x*value`) // 配置位置通道映射规则
    .color('type')
    .adjust({
      type: 'dodge',
      marginRatio: 0,
    })
    .style({ opacity: 0.4 })
    .tooltip({
      fields: ['type', 'value'],
      callback(type, y) {
        return {
          name: item.indexes.find((i) => i.id === type).name,
          value: y,
        };
      },
    });
  if (displayConfig.showData) {
    G.label('value', {
      layout: {
        type: 'limit-in-shape'
      }
    })
  } else {
    G.label(false)
  }
  chart.scale({
    x: {
      type: 'cat',
      alias: '哈哈',
    },
  });
  chart.axis('value', {
    label: {
      formatter: (val) => {
        return val;
      },
    },
  });
  chart.axis('x', {
    verticalFactor: -1,
    label: {
      autoEllipsis: true,
      formatter: (val, itemList, index) => {
        return val;
      },
    },
    title: null,
  });
  let legendCfg: any | boolean = false
  if (displayConfig.showLegend) {
    legendCfg = {
      position: displayConfig.position,
      itemName: {
        formatter(text) {
          return item.indexes.find((i) => i.id === text).name;
        },
      },
    };
  }
  chart.legend(legendCfg);
  // chart.interaction('element-active');
  chart.render();
}
/**
 * 柱状图
 * @param chart 
 * @param item 
 * @param displayConfig 
 */
export const columnar = (chart, item, displayConfig) => {
  chart.data(getBarData(item))
  const G = chart.interval()
    .position(`x*value`) // 配置位置通道映射规则
    .color('type')
    .adjust({
      type: 'dodge',
      marginRatio: 0
    })
    .style({ opacity: 0.4 })
    .tooltip({
      fields: ['type', 'value'],
      callback(type, y) {
        return {
          name: item.indexes.find((i) => i.id === type).name,
          value: y
        }
      }
    })
  if (displayConfig.showData) {
    G.label('value', {
      layout: {
        type: 'limit-in-shape'
      }
    })
  } else {
    G.label(false)
  }
  chart.scale({
    x: {
      type: 'cat',
    },
  })
  chart.axis('value', {
    label: {
      formatter: (val) => {
        return val
      }
    }
  })
  chart.axis('x', {
    verticalFactor: -1,
    label: {
      autoEllipsis: true,
      formatter: (val, itemList, index) => {
        return val
      }
    },
    title: null
  })

  let legendCfg: any | boolean = false
  if (displayConfig.showLegend) {
    legendCfg = {
      position: displayConfig.position,
      itemName: {
        formatter(text) {
          return item.indexes.find((i) => i.id === text).name
        }
      }
    }
  }
  chart.legend(legendCfg)
  chart.render()
}
/**
 * 折线图
 * @param chart 
 * @param item 
 */
export const line = (chart, item, displayConfig) => {
  chart.data(getBarData(item))
  const G = chart.line()
    .position(`x*value`) // 配置位置通道映射规则
    .color('type')
    .shape('smooth')
    .style({ opacity: 0.4 })
    .tooltip({
      fields: ['type', 'value'],
      callback(type, y) {
        return {
          name: item.indexes.find((i) => i.id === type).name,
          value: y
        }
      }
    })
  // if (displayConfig.showData) {
  //   G.label('value', {
  //     layout: {
  //       type: 'limit-in-shape'
  //     }
  //   })
  // } else {
  //   G.label(false)
  // }
  G.label(false)
  // G.label('x', (xValue) => {
  //   return {
  //     content: xValue + '%',
  //     layout: {
  //       type: 'overlap-label'
  //     }
  //   };
  // })
  chart.scale({
    x: {
      type: 'cat',
      alias: '哈哈'
    },
  })
  chart.axis('value', {
    label: {
      formatter: (val) => {
        return val
      }
    }
  })
  chart.axis('x', {
    verticalFactor: -1,
    label: {
      autoEllipsis: true,
      formatter: (val, itemList, index) => {
        return val
      }
    },
    title: null
  })
  // if (dimensions.length > 1) {
  //   chart.annotation().text({
  //     position: ['互联网-国内', 50],
  //     content: '1111',
  //     top: true
  //   })
  // }
  // 显示提示时隐藏标记
  let legendCfg: any | boolean = false
  if (displayConfig.showLegend) {
    legendCfg = {
      position: displayConfig.position,
      itemName: {
        formatter(text) {
          return item.indexes.find((i) => i.id === text).name
        }
      }
    }
  }
  chart.legend(legendCfg)
  chart.render();
}
/**
 * 饼状图
 * @param chart 
 * @param item 
 */
export const pie = (chart, item, displayConfig) => {
  chart.coordinate({
    type: 'theta',
    cfg: { radius: 0.8 }
  })
  chart.data(getPieData(item))

  let G = chart
    .interval()
    .adjust('stack') // 设置数据调整方式
    .position('value') // 配置位置通道映射规则
    .color('type')  // 配置颜色通道映射规则
    .style({ opacity: 0.4 })
  if (displayConfig.showData) {
    G.label('value', {
      offset: -5,
      content: (i) => {
        return `${i.type}: ${(i.percent * 100).toFixed(2)}%`
      },
      layout: {
        type: 'limit-in-shape'
      }
    })
  } else {
    G.label(false)
  }
  chart.scale('type', {
    type: 'cat'
  })
  chart.scale('percent', {
    formatter: (val) => {
      val = val * 100 + '%';
      return val;
    }
  })
  // 显示提示时隐藏标记
  let legendCfg: any | boolean = false
  if (displayConfig.showLegend) {
    legendCfg = {
      position: displayConfig.position
    }
  }
  chart.legend(legendCfg)
  // chart.interaction('element-active')
  chart.render();
}
/**
 * 漏斗图
 * @param chart 
 * @param item 
 */
export const funnel = (chart, item, displayConfig) => {
  chart.source(getFunnelData(item));
  chart.axis(false);
  chart
    .coordinate('rect')
    .transpose()
    .scale(1, -1)
  chart.tooltip({
    showMarkers: false // 是否渲染tooltipMarkers
  })
  // 创建几何标记负责数据到图形属性的映射以及绘制逻辑

  const G = chart
    .interval()
    .adjust('symmetric') // 设置数据调整方式
    .position('type*value') // 配置位置通道映射规则
    .shape('pyramid')
    .color('type')  // 配置颜色通道映射规则
  chart.scale('type', {
    type: 'cat'
  })
  // if (displayConfig.showData) {
  //   G.label(
  //     'type*value',
  //     (type, value) => {
  //       return {
  //         content: `${type} ${value}`,
  //         layout: {
  //           type: 'limit-in-shape'
  //         }
  //       };
  //     },
  //     {
  //       offset: 35,
  //     })
  // } else {
  //   G.label(false)
  // }
  // 显示提示时隐藏标记
  let legendCfg: any | boolean = false
  if (displayConfig.showLegend) {
    legendCfg = {
      position: displayConfig.position
    }
  }
  chart.legend(legendCfg)
  chart.render();
}
/**
 *  旭日图
 * @param chart 
 * @param item 
 */
export const sunburst = (chart, item, displayConfig) => {
  let { showLegend = false, showData = false, position } = displayConfig
  let { indexes } = item
  // 创建图表对象
  chart.data(getData(item));
  chart.scale({
    x: {
      nice: true,
    },
    y: {
      nice: true,
    },
  });

  chart.coordinate('polar', {
    innerRadius: 0.3,
  });
  // chart.tooltip({
  //   showTitle: false,
  //   showMarkers: false,
  // });
  chart.axis(false);
  const G = chart
    .polygon()
    .position('x*y')
    .color('value', '#BAE7FF-#0050B3')
    .style({
      stroke: '#FFF',
      lineWidth: 1,
    })
    .tooltip({
      fields: ['name', 'value', 'percent'],
      callback(name, value, percent) {
        return {
          name,
          value,
          percent: (percent * 100).toFixed(2) + '%'
        }
      }
    })
  if (showData) {
    G.label('value', {
      offset: -5,
      content: (i) => {
        return `${i.name}: ${(i.percent * 100).toFixed(2)}%`
      },
      layout: {
        type: 'limit-in-shape'
      }
    })
  } else {
    G.label(false)
  }
  // 显示提示时隐藏标记
  let legendCfg: any | boolean = false
  if (showLegend) {
    legendCfg = {
      position,
      slidable: false,
      title: {
        text: indexes[0].name,
        textAlign: 'center'
      }
    }
  }
  chart.tooltip({
    showTitle: false,
    domStyles: {
      'g2-tooltip-marker': {

      }
    },
    itemTpl: '<ul class="g2-tooltip-list">' +
      '<li class="g2-tooltip-list-item"></span><span class="g2-tooltip-name">{name}</span>:<span class="g2-tooltip-value">{value}</span></li>' +
      '<li class="g2-tooltip-list-item"><span class="g2-tooltip-name">占比</span>:<span class="g2-tooltip-value">{percent}</span></li>' +
      '</ul>'
  })
  chart.legend(legendCfg)
  chart.interaction('element-active');

  chart.render();
}
/**
 * 地图
 * @param chart 
 * @param item 
 */
export const map = (chart, item, displayConfig) => {
  const { data = [], indexes = [], dimensions = [] } = item
  const { showLegend = false, showData = false, position } = displayConfig
  fetch('https://gw.alipayobjects.com/os/antvdemo/assets/data/china-provinces.geo.json')
    .then(res => res.json())
    .then(mapData => {
      chart.tooltip({
        showTitle: false,
        showMarkers: false,
        shared: true,
      });
      // 同步度量
      chart.scale({
        longitude: {
          sync: true
        },
        latitude: {
          sync: true
        }
      });
      chart.axis(false);
      let legendCfg: any | boolean = false
      if (showLegend) {
        legendCfg = {
          position,
          slidable: false,
          title: {
            text: indexes[0].name,
            textAlign: 'center'
          }
        }
      }
      chart.legend(legendCfg)
      const { rows, rowsItem } = getMap(mapData, item)
      const chinaMapView = chart.createView()
      chinaMapView.data(rows);
      chinaMapView.tooltip(false);
      chinaMapView.polygon().position('longitude*latitude').style({
        fill: '#ddd',
        stroke: '#ccc',
        lineWidth: 1
      });

      const userView = chart.createView();
      userView.data(rowsItem);
      userView.scale(item.indexes[0].id, { type: 'linear' })
      const G = userView.polygon()
        .position('longitude*latitude')
        .color(item.indexes[0].id, ['#FFBF00', '#FF3333'])
        .style({
          fillOpacity: 0.85
        })
        .animate({
          leave: {
            animation: 'fade-out'
          }
        })
        .tooltip({
          fields: [item.dimensions[0].id, item.indexes[0].id],
          callback(name, value) {
            return {
              name,
              value
            }
          }
        })
      // if (showData) {
      //   G.label(
      //     `${dimensions[0].id}*${indexes[0].id}`,
      //     (a, b) => {
      //       return {
      //         content: `${a} ${b}`,
      //         layout: {
      //           type: 'limit-in-shape'
      //         }
      //       };
      //     },
      //     {
      //       style: {
      //         lineWidth: 1,
      //         fill: '#262626'
      //       },
      //     })
      // } else {
      //   G.label(false)
      // }
      chart.render()
    })
}
/**
 * 甘特图
 * @param chart 
 * @param item 
 * @param displayConfig 
 */
export const gantt = (chart, item, displayConfig) => {
  const { data = [], indexes = [], dimensions = [] } = item
  const { showLegend = false, showData = false, position } = displayConfig
  // 坐标系翻转
  chart.coordinate().transpose();
  chart.data(ganttDv(item));
  if (showData) {
    chart
      .interval()
      .position('type*value')
      .color('val', ['#2194ff'])
      .adjust('dodge')
      .tooltip({
        fields: ['type', 'value', 'day'],
        callback(type, y, day) {
          return {
            name: '开始时间',
            value: y[0],
            name1: '结束时间',
            value1: y[1],
            name2: '持续时间',
            value2: day,
          };
        },
      });
    // .label('value', {
    // 	style: {
    // 		fill: '#8d8d8d',
    // 	},
    // 	offset: 10,
    // 	content: (originData) => {
    // 		return (originData.value + '').replace(/(\d)(?=(?:\d{3})+$)/g, '$1,');
    // 	},
    // });
  } else {
    chart
      .interval()
      .position('type*value')
      .color('val', ['#2194ff'])
      .adjust('dodge')
      .label('')
      .tooltip({
        fields: ['type', 'value', 'day'],
        callback(type, y, day) {
          return {
            name: '开始时间',
            value: y[0],
            name1: '结束时间',
            value1: y[1],
            name2: '持续时间',
            value2: day,
          };
        },
      });
  }
  // 显示提示时隐藏标记
  chart.legend(false);
  chart.interaction('active-region');
  chart.render();
}
